import { keikkaBetoni_cacheName, cache_clear } from "src/components/js/CacheFunctions";

export default class betoniLaatuClass {
  constructor() {
    this.laatuId = 0;
    this.nimike = "";
    this.helpId = "Betonin laatu ei tiedossa";
  }
  set(obj) {
    this.laatuId = obj.laatuId;
    this.nimike = obj.laatuNimike;
    this.helpId = obj.laatuHelpId;
  }
}

export async function saveBetoniLaatuToDB(laatu, token) {
  cache_clear(keikkaBetoni_cacheName);
  const addr = "/api/betoni/laatu/save";
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(laatu),
  };
  const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, requestOptions)
    .then((response) => {
      if (!response.ok) {
        throw Error("Save failed");
      }
      return response;
    })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((error) => {
      throw Error(error);
    });
  return response;
}

export async function createNewBetoniLaatu(asiakasId, token) {
  cache_clear(keikkaBetoni_cacheName);
  const addr = "/api/betoni/laatu/new";
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ asiakasId: asiakasId }),
  };
  const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, requestOptions)
    .then((response) => {
      if (!response.ok) {
        throw Error("Create failed");
      }
      return response;
    })
    .then((response) => response.json())
    .then((data) => {
      return data;
    })
    .catch((error) => {
      throw Error(error);
    });
  return response;
}
